__turbopack_context__.v({
  "info": "tweet-info-module___F14PW__info",
  "infoIcon": "tweet-info-module___F14PW__infoIcon",
  "infoLink": "tweet-info-module___F14PW__infoLink",
});
